var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticStyle: { width: "1000px" } },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            attrs: {
              model: _vm.data,
              rules: _vm.rules,
              "label-width": "110px",
            },
          },
          [
            _c("el-form-item", { attrs: { label: "税率", prop: "taxRate" } }, [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _vm.hasCheck
                    ? _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { type: "number" },
                        model: {
                          value: _vm.num,
                          callback: function ($$v) {
                            _vm.num = $$v
                          },
                          expression: "num",
                        },
                      })
                    : _c("span", [_vm._v(_vm._s(_vm.num))]),
                  _vm._v("\n           %\n\n          "),
                  _c("div", { staticStyle: { "margin-left": "20px" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "red",
                          "font-size": "12px",
                          "line-height": "16px",
                        },
                      },
                      [
                        _vm._v(
                          "\n              用于渠道佣金结算计算：\n              "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n              佣金=完单订单的实际收款金额（扣除退款、优惠券等）/(1+税率 ）x 佣金比例\n            "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px", "padding-left": "20px" } },
          [_vm._v("最新操作人：" + _vm._s(_vm.data.username))]
        ),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px", "padding-left": "20px" } },
          [_vm._v("操作时间：" + _vm._s(_vm.data.updateTime))]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "has-permi",
                rawName: "v-has-permi",
                value: ["channel_taxrate_save"],
                expression: "['channel_taxrate_save']",
              },
            ],
            staticStyle: { "padding-left": "300px" },
          },
          [
            _c(
              "el-button",
              {
                attrs: { loading: _vm.loading, type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.submitForm("ruleForm")
                  },
                },
              },
              [_vm._v("\n        保存\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }